// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"qu","text":"qv","subText":"qw","toggleContainer":"qx","checked":"qy"};